export default __webpack_public_path__ + "static/media/umbrella.ea023858.svg";